import { render, staticRenderFns } from "./lawdettyls.vue?vue&type=template&id=57aa0352&scoped=true&"
import script from "./lawdettyls.vue?vue&type=script&lang=js&"
export * from "./lawdettyls.vue?vue&type=script&lang=js&"
import style0 from "./lawdettyls.vue?vue&type=style&index=0&id=57aa0352&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57aa0352",
  null
  
)

export default component.exports